var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"main",on:{"click":function($event){return _vm.closePreview()}}},[_vm._v(" 1 | "+_vm._s(_vm.translate('general_back'))+" ")]),_vm._l((_vm.actions),function(action){return _c('button',{key:action.id,staticClass:"action",on:{"click":function($event){action.id === 'ticketRebet'
    ? _vm.callRebet()
    : _vm.actionTicketPreview(action)}}},[_vm._v(" "+_vm._s(action.key)+" | "+_vm._s(action.text)+" ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }